var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectOffice1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 1270,
    viewBox: "0 0 2500 1270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "A1",
    d: "M238 500H108.5V949.5H237.5V751H242V628H238V500Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "A2",
    d: "M603.5 500H238V628.002H242V751.002H237.5V949.502H603.5V500Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "A3",
    d: "M963.5 500H603.5V949.5H1163V861.5H1217.5V632.5H1155V425.5H1091H963.5V500Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "A4",
    d: "M1217.5 425.5H1155V632.5H1217.5V425.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "disabled",
    d: "M1279.5 425.5H1217.5V656.5H1279.5V425.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "disabled",
    d: "M1279.5 411V425.5V656.5H1217.5V861.5H1831V411H1279.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "disabled",
    d: "M2324 411H1831V861.5H2324V411Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectOffice1);
export default __webpack_public_path__ + "static/media/select-office-1.891ff0ee.svg";
export { ForwardRef as ReactComponent };